const stockEntityDefaultLabels = {
  name: "Имя",
  type: "Тип",
  barcode: "Штрихкод",
  vendor_code: "Артикул",
};

const cloth = {
  labels: {
    ...stockEntityDefaultLabels,
    additional_info: "Дополнительно",
    text_description: "Текстовое описание",
    color: "Цвет",
    unit_price: "Стоимость за 1 ед. (руб.)",
    structure: "Состав",
    width: "Ширина",
    winding: "Намотка",
    density: "Плотность",
    vendor_code: "Ткани",
    provider_vendor_code: "Поставщика",
  },
  maxlength: {
    name: 160,
    type: 160,
    barcode: 70,
    vendor_code: 70,
    additional_info: 240,
    text_description: 1000,
    color: 100,
    unit_price: 100,
    structure: 1000,
    width: 180,
    winding: 180,
    density: 180,
    provider_vendor_code: 60,
  },
};

const cutOfClothes = {
  labels: {
    ...stockEntityDefaultLabels,
    unit_price: "Стоимость за 1 ед. (руб.)",
  },
  maxlength: {
    name: 160,
    type: 160,
    unit_price: 100,
    barcode: 60,
    vendor_code: 60,
  },
};

const expendableMaterial = {
  labels: {
    ...stockEntityDefaultLabels,
    text_description: "Текстовое описание",
    length: "Длина (намотка)",
    thickness: "Диаметр",
    structure: "Материал (состав)",
    weight: "Вес",
    volume: "Объем",
    color: "Цвет",
    brand: "Бренд",
  },
  maxlength: {
    name: 180,
    type: 180,
    barcode: 60,
    vendor_code: 60,
    text_description: 1000,
    length: 180,
    thickness: 180,
    structure: 1000,
    weight: 180,
    volume: 180,
    color: 150,
    brand: 160,
  },
};

const stationery = {
  labels: {
    ...stockEntityDefaultLabels,
    stationery_subtype: "Подтип",
  },
  maxlength: {
    name: 180,
    type: 180,
    stationery_subtype: 180,
    barcode: 80,
    vendor_code: 80,
  },
};

const promotionalProduct = {
  labels: {
    ...stockEntityDefaultLabels,
    unit_price: "Стоимость за 1 ед. (руб.)",
    text_description: "Текстовое описание",
  },
  maxlength: {
    name: 140,
    type: 140,
    barcode: 80,
    vendor_code: 80,
    text_description: 1000,
    unit_price: 100,
  },
};

const sewingAccessory = {
  labels: {
    ...stockEntityDefaultLabels,
    color: "Цвет",
    weight: 'Вес 1 ед. (г)',
    length: "Длина",
    unit_price: "Стоимость за 1 ед. (руб.)",
    length_unit: "Единицы длины",
    material: "Материал",
    width_unit: "Единицы намотки",
    width: "Ширина",
    thickness: "Диаметр",
    thickness_unit: "Единицы диаметра",
  },
  maxlength: {
    name: 180,
    type: 180,
    weight: 120,
    barcode: 60,
    unit_price: 100,
    vendor_code: 60,
    color: 180,
    length: 180,
    material: 1000,
    width: 180,
    thickness: 180,
  },
};

const packageItem = {
  labels: {
    ...stockEntityDefaultLabels,
    text_description: "Текстовое описание",
    color: "Цвет",
    length: "Длина",
    width: "Ширина",
    height: "Высота",
    unit_price: "Стоимость за 1 ед. (руб.)",
  },
  maxlength: {
    name: 180,
    type: 180,
    barcode: 80,
    vendor_code: 80,
    color: 180,
    unit_price: 100,
    length: 180,
    width: 150,
    height: 150,
  },
};

const product = {
  labels: {
    ...stockEntityDefaultLabels,
    subtype: "Подтип",
    gender: "Пол",
    price: "Цена",
    color: "Цвет",
    filler_material: "Материал заполнителя",
    text_description: "Текстовое описание",
    cloth_structure: "Состав ткани",
    lining_structure: "Состав подкладки",
    care_advices: "Инструкция по уходу",
    artistic_description: "Художественное описание",
    NDS: "НДС",
    season: "Сезон",
    collection: "Коллекция",
    style: "Стиль",
    amount_in_package: "Количество в упаковке",
    collar_form: "Форма воротника/горловины",
    waist: "Талия",
    clothing_type: "Вид одежды",
    details: "Детали",
    package_item: "Упаковка",
    parent: "Родитель",
    sizes_data: "Размеры",
    cut_of_clothes: "Крой",
    cloths_data: "Ткани",
    sewing_accessories_data: "Вся фурнитура",
    packages_data: "Упаковки",
    promotional_products_data: "Вся рекламная продукция",
  },
  maxlength: {
    name: 180,
    type: 180,
    barcode: 80,
    vendor_code: 80,
    subtype: 180,
    gender: 80,
    price: 120,
    text_description: 1000,
    care_advices: 1800,
    artistic_description: 1600,
  },
};

const POSSIBLE_STATUSES = ['в работе', 'выполнен', 'отменен'];

const project = {
  labels: {
    name: "Название",
    status: "Статус",
    user_id: "Ответственный пользователь",
    products_data: "Продукты",
  },
  maxlength: {
    name: 180,
  },
  statusValues: POSSIBLE_STATUSES,
};

const purchaseOrder = {
  labels: {
    number: "Номер",
    status: "Статус",
    client_id: "Клиент",
    price: "Стоимость",
    shipping_date: "Дата отгрузки",
  },
  maxLength: {
    number: 80,
    status: 80,
    client_id: 80,
    price: 80,
    shipping_date: 80,
  },
  types: {
    number: 'text',
    price: 'text',
    shipping_date: 'date',
  },
  statusValues: POSSIBLE_STATUSES,
};

export const formsFields = {
  cloth,
  cutOfClothes,
  expendableMaterial,
  stationery,
  promotionalProduct,
  sewingAccessory,
  packageItem,
  project,
  product,
  purchaseOrder,
};



// WEBPACK FOOTER //
// ./src/stock/constants/formsFields.js